import type { MapStateToPropsFactory } from 'react-redux';
import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { secondaryMarketDlpOrderPlacementRequestedThunk } from 'state/secondaryMarket/dlpOrder/order/order.thunks';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { isSecondaryMarketTradeEnabledForUser } from 'state/user';

type OwnProps = Readonly<{
  tabId: string;
  className?: string;
}>;

type StateProps = Readonly<{
  isOrderPlacementEnabled: boolean;
}>;

type DispatchProps = Readonly<{
  onPlaceOrder: () => void;
}>;

export type ReadySidePanelProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps: MapStateToPropsFactory<StateProps, OwnProps, AppState> = () => {
  return (state: AppState): StateProps => {
    const isOrderPlacementEnabled = isSecondaryMarketTradeEnabledForUser(state);
    return {
      isOrderPlacementEnabled,
    };
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => {
  return {
    onPlaceOrder() {
      dispatch(secondaryMarketDlpOrderPlacementRequestedThunk(tabId));
      logAnalytics.trackEvent('Secondary market', 'Request for dlp place order');
    },
  };
};

export const connectReadySidePanel = connect(mapStateToProps, mapDispatchToProps);
